/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class EFSRestoreDestination {
  /**
  * AWS region where the EFS file system will be restored.
  */
  'region': string;
  /**
  * Name for the restored EFS file system (set as the Name tag).
  */
  'fileSystemName'?: string;
  /**
  * Subnet IDs for the restored file system mount targets. At least one subnet is required.
  */
  'subnetIds': Array<string>;
  /**
  * Security group IDs for mount targets. If not provided, the default security group will be used.
  */
  'securityGroupIds'?: Array<string>;
  /**
  * KMS key ARN for encrypting the restored file system. If not provided, AWS managed encryption will be used.
  */
  'encryptionKey'?: string;
  /**
  * Performance mode for the restored file system. If not provided, the original performance mode will be used.
  */
  'performanceMode'?: EFSRestoreDestinationPerformanceModeEnum;
  /**
  * Throughput mode for the restored file system. If not provided, the original throughput mode will be used.
  */
  'throughputMode'?: EFSRestoreDestinationThroughputModeEnum;
  /**
  * Provisioned throughput in MiB/s. Only applicable when throughputMode is \'provisioned\'.
  */
  'provisionedThroughputMibps'?: number;
  /**
  * Tags to apply to the restored file system.
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "fileSystemName",
      "baseName": "fileSystemName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetIds",
      "baseName": "subnetIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "securityGroupIds",
      "baseName": "securityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "performanceMode",
      "baseName": "performanceMode",
      "type": "EFSRestoreDestinationPerformanceModeEnum",
      "format": ""
    },
    {
      "name": "throughputMode",
      "baseName": "throughputMode",
      "type": "EFSRestoreDestinationThroughputModeEnum",
      "format": ""
    },
    {
      "name": "provisionedThroughputMibps",
      "baseName": "provisionedThroughputMibps",
      "type": "number",
      "format": "double"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EFSRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum EFSRestoreDestinationPerformanceModeEnum {
  GeneralPurpose = 'generalPurpose',
  MaxIo = 'maxIO'
}
export enum EFSRestoreDestinationThroughputModeEnum {
  Bursting = 'bursting',
  Provisioned = 'provisioned',
  Elastic = 'elastic'
}

